export default __webpack_public_path__ + "static/christophe-fb47f46d58f557d0a58beaab16473c68.png";